import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=0320e65c&scoped=true"
import script from "./forward.vue?vue&type=script&lang=js"
export * from "./forward.vue?vue&type=script&lang=js"
import style0 from "./forward.vue?vue&type=style&index=0&id=0320e65c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0320e65c",
  null
  
)

export default component.exports